import linkedin from "../../../../assets/img/social/linkedin.png";
import github from "../../../../assets/img/social/github.png";
import mail from "../../../../assets/img/social/mail.png";

export const Social = {
  linkedinSrc: linkedin,
  linkedinLink: "https://www.linkedin.com/in/emanuel-mt",
  githubSrc: github,
  githubLink: "https://www.github.com/ManuuMT",
  mailSrc: mail,
  mailLink: "mailto:emtuero@hotmail.com",
};
